import React, { useState, useEffect } from 'react';
import { Database, BookOpen, Shield, Upload, RefreshCw, Zap } from 'lucide-react';
import DataSourceConfig from './components/DataSourceConfig/DataSourceConfig';
import DataDictionary from './components/DataDictionary/DataDictionary';
import RuleTypes from './components/RuleTypes/RuleTypes';
import ValidationRules from './components/ValidationRules/ValidationRules';
import FileUploadValidation from './components/FileUpload/FileUploadValidation';
import storageService from './services/storageService';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('datasource');
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize sample data if needed
    const dataSources = storageService.getDataSources();
    if (dataSources.length === 0) {
      storageService.initializeSampleData();
    }
    setIsInitialized(true);
  }, []);

  const handleResetData = () => {
    if (window.confirm('Bạn có chắc muốn xóa toàn bộ dữ liệu và tải lại dữ liệu mẫu?')) {
      storageService.clearAll();
      storageService.initializeSampleData();
      window.location.reload();
    }
  };

  const tabs = [
    { id: 'datasource', label: 'Nguồn Dữ liệu', icon: Database },
    { id: 'dictionary', label: 'Data Dictionary', icon: BookOpen },
    { id: 'ruletypes', label: 'Loại Rule', icon: Zap },
    { id: 'rules', label: 'Validation Rules', icon: Shield },
    { id: 'upload', label: 'Upload & Validate', icon: Upload }
  ];

  if (!isInitialized) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Đang tải...</p>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-content">
          <div className="logo">
            <div className="logo-icon"></div>
            <h1>Data Quality <span className="brand">Management</span></h1>
          </div>
          <div className="header-actions">
            <button 
              className="btn btn-secondary btn-sm"
              onClick={handleResetData}
              title="Reset dữ liệu mẫu"
            >
              <RefreshCw size={16} /> Reset Data
            </button>
          </div>
        </div>
      </header>

      <nav className="app-nav">
        <div className="nav-container">
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <Icon size={20} />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </nav>

      <main className="app-main">
        {activeTab === 'datasource' && <DataSourceConfig />}
        {activeTab === 'dictionary' && <DataDictionary />}
        {activeTab === 'ruletypes' && <RuleTypes />}
        {activeTab === 'rules' && <ValidationRules />}
        {activeTab === 'upload' && <FileUploadValidation />}
      </main>

      <footer className="app-footer">
        <p>© 2026 Data Quality Management POC</p>
      </footer>
    </div>
  );
}

export default App;
